module.exports = __webpack_public_path__ + "img/davey.e4292a8d.png";